import React, {Component} from "react";
import _ from "lodash";

class ResultTable extends Component {
    state = {
        sortColumn: { path: "subjects_summary.percentage", order: "desc" },
    };

    setFilter = (filterPath) => {
        if (filterPath === '') return;

        let {path, order} = this.state.sortColumn;


        if (path === filterPath)
            order = order === 'asc' ? 'desc' : 'asc'
        else
            path = filterPath;

        this.setState({sortColumn: {path, order}})
    }

    tableHeaderCell =(data, filterPath='', colSpan=1, key='') => {
        return (
            <th key={key !== '' ? key : data + filterPath} style={{border: "1px solid #c1c1c1", background: "none"}}
                colSpan={colSpan}
                onClick={()=>this.setFilter(filterPath)}
            >
                <div style={{color: "var(--blue)", textAlign: "center" }}>{data}</div>
            </th>
        );
    }

    tableBodyCell =(data, key='', backgroundColor) => {
        return (
            <td key={data + key} style={{border: "1px solid #c1c1c1", backgroundColor}}>
                {data}
            </td>
        );
    }

    renderLink = (e) => {
        return (
            <td key={e.student_id} style={{border: "1px solid #c1c1c1"}}>
                <span className="class-result-summary-name">{e.student_name}</span>
            </td>
        );
    };


    getResult = (result) => {
        let res = 'نامعلوم'

        if (result === 0) res = 'ناکام';
        else if (result === 1) res = 'کامیاب';
        else if (result === 2) res = 'محروم';

        return res
    }


    render() {
        const {students, subjects} = this.props;
        const {path, order} = this.state.sortColumn;
        let sortedStudents = _.orderBy(students, [path], [order]);

        let counter = 1;

        return (
            <div
                className="print-table-area"
                style={{
                    width: "100%",
                    minHeight: "100%",
                    fontSize: "12px",
                }}>
                <table  style={{
                    height: "100%",
                    width: "100%",
                    border: "1px solid rgb(193, 193, 193)",
                    borderRadius: "5px",
                }}>
                    {/* Table Header */}
                    <thead>
                    <tr>
                        {this.tableHeaderCell('مشخصات', '', 6)}

                        {Object.keys(subjects).map(subject => this.tableHeaderCell(subject))}

                        {this.tableHeaderCell('نتیجه نهایی', '', 6)}
                    </tr>
                    <tr>
                        {this.tableHeaderCell('شماره')}
                        {this.tableHeaderCell('کد دانشجو', 'aria_id')}
                        {this.tableHeaderCell('نام', 'student_name')}
                        {this.tableHeaderCell('تخلص', 'student_lastname')}
                        {this.tableHeaderCell('نام پدر', 'student_father_name')}
                        {this.tableHeaderCell('نام پدرکلان', 'grand_father_name')}

                        {Object.keys(subjects).map(s => this.tableHeaderCell(subjects[s].subject?.credits, '', 1, s))}

                        {this.tableHeaderCell('تعداد کردیت')}
                        {this.tableHeaderCell('مجموع', 'subjects_summary.total')}
                        {this.tableHeaderCell('معدل', 'subjects_summary.percentage')}
                        {this.tableHeaderCell('GPA', 'subjects_summary.GPA')}
                        {this.tableHeaderCell('نتیجه', 'subjects_summary.result')}
                        {this.tableHeaderCell('ملاحظات')}
                    </tr>
                    </thead>


                    {/* Table Body */}
                    <tbody>{
                        sortedStudents &&
                        sortedStudents?.map((student, i) => {
                        return (<tr key={student.student_id}>
                            {this.tableBodyCell(counter++)}
                            {this.tableBodyCell(student.aria_id)}
                            {this.renderLink(student)}
                            {this.tableBodyCell(student.student_lastname)}
                            {this.tableBodyCell(student.student_father_name)}
                            {this.tableBodyCell(student.grand_father_name)}

                            {Object.keys(subjects).map(subject => {
                                let final = null;
                                let students = subjects[subject].students

                                for (let currentStudent of students) {
                                    if (currentStudent.student_id === student.student_id) {
                                        final = currentStudent.final_total
                                        break;
                                    }
                                }


                                let backgroundColor = final !=null && final < 55 ? 'rgba(255,92,55,0.41)' : null
                                let key = `${student.student_id}-${subject}-${i}`

                                return this.tableBodyCell(final ?? '', key  , backgroundColor)
                            })}


                            {this.tableBodyCell(student.subjects_summary?.credits, student.student_id + '_credits')}
                            {this.tableBodyCell(student.subjects_summary?.total, student.student_id + '_total')}
                            {this.tableBodyCell(student.subjects_summary?.percentage, student.student_id + '_percentage')}
                            {this.tableBodyCell(student.subjects_summary?.GPA, student.student_id + '_GPA')}
                            {this.tableBodyCell(this.getResult(student.subjects_summary?.result), student.student_id + '_result')}
                            {this.tableBodyCell(student.subjects_summary?.remark, student.student_id + '_remark')}

                        </tr>)
                    })}</tbody>
                </table>
            </div>
        );
    }
}

export default ResultTable;
